import 'ui-theme/widgets/slideshow/js/slideshow';
(function () {
    UX.slider.backgroundSlideshow = function () {
        const sourceSlideshow = $('.main-slider .owl-carousel');
        if (sourceSlideshow.length && !sourceSlideshow[0].attachedSlideshow) {
            const slides = sourceSlideshow.find('.slide-item');
            if (!slides.length) {
                return;
            }
            const slideshow = $('<div>');
            slideshow.addClass('owl-carousel top-banner__bkg-carousel');

            slides.each((i, o) => {
                const img = $(o).find('img.hidden');
                o.dataset.key = i;

                if (img.length) {
                    const item = $('<div>');
                    item.css('background-image', `url('${img[0].src}')`);
                    slideshow.append($(item));
                }
            });

            slideshow.owlCarousel({
                items: 1,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
                dots: false,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
            });
            sourceSlideshow.on('change.owl.carousel', function (e) {
                const current = sourceSlideshow.find('.owl-item').eq(e.property.value);
                const active = current.find('.slide-item');
                if (e.property && e.property.name === 'position') {
                    slideshow.trigger('to.owl.carousel', [active.data('key')]);
                }
            });

            sourceSlideshow[0].attachedSlideshow = slideshow;
            $('.top-banner').prepend(slideshow);
        }
    };

    // UX.slider.additionalInit = function () {
    //     UX.slider.backgroundSlideshow()
    // }

    UX.slider.beforeInitSlider = function (sliderEl) {
        let options = {};
        let standardNavs = [
            '<i class="icon-arrow_l" aria-hidden="true"></i><span class="sr-only">previous</span>',
            '<i class="icon-arrow_r" aria-hidden="true"></i><span class="sr-only">next</span>',
        ];
        if (screen.width < 1024) {
            standardNavs = [
                '<i class="icon-arrow_l"></i><span class="sr-only">previous</span>',
                '<i class="icon-arrow_r"></i><span class="sr-only">next</span>',
            ];
        } else {
            standardNavs = [
                '<i class="icon-arrow_l" aria-hidden="true"></i><span class="sr-only">previous</span>',
                '<i class="icon-arrow_r" aria-hidden="true"></i><span class="sr-only">next</span>',
            ];
        }
        let topBannerDots = sliderEl.parents('.top-banner').find('.slideShow__external-dots');
        let topBannerNav = sliderEl.parents('.top-banner').find('.slideShow__external-nav');
        if (topBannerDots.length) {
            options = $.extend(options, {
                dotsContainer: topBannerDots,
                smartSpeed: 350,
            });

            if (window.innerWidth > UX.grid.screenMd) {
                options.animateOut = 'fadeOutDownSlowFade';
                options.animateIn = 'fadeInDownSlowFade';
            }
        }

        if (topBannerNav.length) {
            options.navContainer = topBannerNav;
            options.navText = standardNavs;
            UX.slider.backgroundSlideshow();
        }

        UX.slider.options = $.extend(UX.slider.options, options);

        // if ( sliderEl.parents('.journals-hp-slider').length ) {
        //     UX.slider.options = $.extend(UX.slider.options, {
        //         animateOut: 'fadeOutDownSlowFade',
        //         animateIn: 'fadeInDownSlowFade',
        //         smartSpeed: 350
        //     });
        // }

        // if (sliderEl.parents('.journals-hp-slider').length && window.innerWidth <= UX.grid.screenSm ) {
        //     return false
        // }
        if (config.enableSlideshowIndicator) {
            let $extSlider = $('.main-slider .owl-carousel');
            $('.slideShow__external-dots')
                .find('.owl-dot')
                .each(function () {
                    let $dot = $(this);
                    $dot.attr({
                        role: 'button',
                        title: $extSlider.data('go-to-slide') + ' ' + ($dot.index() + 1),
                        'aria-label': $extSlider.data('go-to-slide') + ' ' + ($dot.index() + 1),
                        tabindex: '0',
                    });
                });
        }
    };

    UX.slider.on.activate = ($element, pass) => {
        const maybeAbort = UX.slider.beforeInitSlider($element);

        if (maybeAbort === false) {
            return;
        }

        /* copied from ux core */
        if (pass || UX.slider.vPort === 'always') {
            $element.owlCarousel(UX.slider.options);
            if ($element.hasClass('slide-removal')) {
                $element.removeClass('slide-removal');
            }
        } else {
            if (!$element.hasClass('slide-removal')) {
                $element.addClass('slide-removal');
            }
        }
    };
    if (screen.width < 767) {
        $('.resources__slider').attr(
            'data-responsive',
            '{"xsMin":{"items":1},"smMin":{"items":1},"mdMin":{"items":1},"lgMin":{"items":1}}'
        );
    } else {
        $('.resources__slider').attr(
            'data-responsive',
            '{"xsMin":{"items":1},"smMin":{"items":1},"mdMin":{"items":2},"lgMin":{"items":3}}'
        );
    }
})();
